module.exports = __webpack_public_path__ + "img/icon-list.98a692f0.svg";